/**
 * Типобезпечний доступ до публічної конфігурації фронта (ADR-0003 D5).
 *
 * У деві `/api` проксується Vite-proxy на Go (`VITE_API_PROXY`, node-side у
 * `vite.config.ts`), тому в браузері базовий префікс — same-origin `/api`.
 * `VITE_API_BASE_URL` лишається опційним override (напр. для ізольованих
 * e2e-стендів); дефолт — `/api`.
 */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",
} as const;
